import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noLocationsMatchYourSearch: {
    id: 'noLocationsMatchYourSearch',
    defaultMessage: 'There are no locations that match your search.',
    description: 'A note to the user that no locations match their entered search term.',
  },
});
